import { Reveal, Overline } from "./Reveal";

const CHAPTERS = [
  {
    n: "01",
    title: "Discover",
    body: "We start by understanding your brand, your audience, and your business goals — deeply, before a single impression is bought.",
    align: "md:ml-0",
  },
  {
    n: "02",
    title: "Strategize",
    body: "Crafting campaigns tailored to your unique objectives — the right mix of programmatic branding and performance channels for your KPIs.",
    align: "md:ml-[12%]",
  },
  {
    n: "03",
    title: "Execute",
    body: "Running campaigns with precision across brand-safe, premium inventory — programmatic, CTV & OTT, social, affiliate, and beyond the screen.",
    align: "md:ml-[6%]",
  },
  {
    n: "04",
    title: "Analyze & Optimize",
    body: "Monitoring CPMs, CTRs, and conversions in real time and refining strategies continuously, because growth is never finished.",
    align: "md:ml-[18%]",
  },
];

export const Manifesto = () => (
  <section id="manifesto" data-testid="manifesto-section" className="py-28 md:py-40">
    <div className="max-w-[1400px] mx-auto px-6 md:px-10">
      <div className="grid md:grid-cols-12 gap-10 mb-24 md:mb-36">
        <Reveal className="md:col-span-4">
          <Overline>The Doctrine</Overline>
        </Reveal>
        <div className="md:col-span-8">
          <Reveal delay={0.1}>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight" data-testid="manifesto-heading">
              Your Digital <span className="italic text-[#8B5CF6]">Growth</span> Architects
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-8 max-w-2xl text-base md:text-lg text-[#A0A0AB] font-light leading-relaxed" data-testid="manifesto-intro">
              AdStellar Media is a programmatic branding and performance
              marketing company. We help brands scale campaigns across every
              category and vertical — on brand-safe, premium worldwide
              inventory, powered by deep integrations with top DSP & SSP
              partners in India and across the globe. Creativity opens the
              door; data and performance carry you through it.
            </p>
          </Reveal>
        </div>
      </div>

      <div className="flex flex-col gap-20 md:gap-28">
        {CHAPTERS.map((c, i) => (
          <Reveal key={c.n} delay={0.05} className={`${c.align} md:max-w-3xl`}>
            <div className="group grid grid-cols-[auto_1fr] gap-6 md:gap-12 items-start border-t border-white/10 pt-10" data-testid={`manifesto-chapter-${c.n}`}>
              <span className="font-accent text-5xl md:text-7xl text-[#2a2a2e] group-hover:text-[#8B5CF6] transition-colors duration-500 leading-none">
                {c.n}
              </span>
              <div>
                <h3 className="font-display text-3xl md:text-5xl italic tracking-tight">{c.title}</h3>
                <p className="mt-4 text-base text-[#A0A0AB] font-light leading-relaxed max-w-xl">{c.body}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
